"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.create = exports.fetch = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const terminalSettingsService_1 = require("./service/terminalSettingsService");
const Env_1 = require("../../utils/tsUtils/Env");
exports.fetch = (0, toolkit_1.createAsyncThunk)("terminalSettings/fetch", (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const terminalSettingsService = new terminalSettingsService_1.TerminalSettingsService(Env_1.APIPATHENV);
        const response = yield terminalSettingsService.fetch(payload);
        return response;
    }
    catch (err) {
        throw new Error("Failed to fetch terminal settings");
    }
}));
exports.create = (0, toolkit_1.createAsyncThunk)("terminalSettings/create", (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const terminalSettingsService = new terminalSettingsService_1.TerminalSettingsService(Env_1.APIPATHENV);
        const response = yield terminalSettingsService.create(payload);
        return response;
    }
    catch (err) {
        throw new Error("Failed to create terminal settings");
    }
}));
exports.update = (0, toolkit_1.createAsyncThunk)("terminalSettings/update", (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const terminalSettingsService = new terminalSettingsService_1.TerminalSettingsService(Env_1.APIPATHENV);
        const response = yield terminalSettingsService.update(payload);
        return response;
    }
    catch (err) {
        throw new Error("Failed to update terminal settings");
    }
}));
